
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ajuda",
      function () {
        return require("private-next-pages/ajuda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ajuda"])
      });
    }
  